import React from 'react';
import Grid from '@material-ui/core/Grid';
import { CssBaseline } from '@material-ui/core';
function NoGrants() {
    return (React.createElement(Grid, { container: true, justify: "center", spacing: 2 },
        React.createElement(CssBaseline, null),
        React.createElement("div", { style: { textAlign: 'center', paddingTop: '120px' } },
            React.createElement("p", null,
                React.createElement("strong", null, "Grants Error")),
            React.createElement("p", null,
                "Your profile has no access to this application.",
                React.createElement("br", null),
                "Please contact support at 1-800-MICHELIN to correct this issue."))));
}
export default NoGrants;
//# sourceMappingURL=NoGrant.js.map